import { AddOrEditIntegrationDrawerFooter } from '@modules/integrationsV2/components/AddOrEditIntegrationDrawerFooter';
import { AddOrEditIntegrationDrawerHeader } from '@modules/integrationsV2/components/AddOrEditIntegrationDrawerHeader';
import { IntegrationDescriptionForm } from '@modules/integrationsV2/components/IntegrationDescriptionForm';
import {
  useUpdateIntegration,
  useValidateIntegrationForm,
} from '@modules/integrationsV2/hooks';
import { EditIntegrationDrawerContentProps } from '@modules/integrationsV2/types';
import { Box, Stack } from '@mui/material';
import { useState } from 'react';
import { IsLoading } from 'v2/core/repository/edge-server/types';

export const EditIntegrationDescriptionDrawerContent = ({
  onDrawerClose,
  integrationChannel,
  integrationType,
  description,
  integrationID,
  namespace,
}: EditIntegrationDrawerContentProps) => {
  const [descriptionInput, setDescriptionInput] = useState(description);

  const [updateIntegration, { status: updateIntegrationStatus }] =
    useUpdateIntegration({
      channelType: integrationChannel.type,
      integrationType,
      onCompleted: () => {
        onDrawerClose();
      },
    });

  const [
    submitForm,
    {
      isDisabled,
      isDescriptionRequired,
      isValidatingDescription,
      descriptionValidForQuestions,
      validatedDescriptionMessage,
      isPreValidatedDescription,
    },
  ] = useValidateIntegrationForm({
    channelType: integrationChannel.type,
    integrationType,
    hasValidFormFields: !!descriptionInput.trim(),
    descriptionInput,
    currentDescription: description,
    onValidated: async () => {
      updateIntegration({
        integrationID,
        isActive: true,
        updateDescription: {
          description: descriptionInput.trim(),
        },
      });
    },
  });

  const integrationTitle = namespace
    ? `${integrationChannel.displayName} - ${namespace}`
    : integrationChannel.displayName;

  return (
    <>
      <Stack height="100%" justifyContent="space-between">
        <Stack>
          <AddOrEditIntegrationDrawerHeader
            integrationChannel={integrationChannel}
            integrationType={integrationType}
            title={`Edit ${integrationTitle} Integration`}
          />
          <Box p={3}>
            <IntegrationDescriptionForm
              value={descriptionInput}
              onChange={setDescriptionInput}
              isRequired={isDescriptionRequired}
              validatedDescriptionMessage={validatedDescriptionMessage}
              isValidationInProgress={isValidatingDescription}
              descriptionValidForQuestions={descriptionValidForQuestions}
              isPreValidatedDescription={isPreValidatedDescription}
              integrationType={integrationType}
            />
          </Box>
        </Stack>
        <AddOrEditIntegrationDrawerFooter
          onCancel={onDrawerClose}
          onSubmit={submitForm}
          isDisabled={isDisabled}
          isLoading={IsLoading(updateIntegrationStatus)}
        />
      </Stack>
    </>
  );
};
